import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "children", "marginBlockEnd"];
import { Text } from '../../../components/Text/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export function TooltipHeader(_ref) {
  let {
      use,
      children,
      marginBlockEnd = '200'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Text, Object.assign({
    as: "h5",
    color: use === 'longform' ? undefined : 'text-core-on-fill-default',
    marginBlockEnd: marginBlockEnd
  }, rest, {
    children: children
  }));
}